import React  from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {
  IComment,
  IDocument,
}             from '@typings/comments';

const LineWrapper = styled.div`
  display       : flex;
  align-items   : center;
  width         : 800px;
  padding       : 5px;
  margin-bottom : 5px;

  span {
    font-size: 16px;
  }

  > span:first-child {
    flex-basis  : 160px;
    text-align  : right;
    white-space : nowrap;
    color       : ${({ theme: { textColor } }): string => textColor.black};
  }

  > span:last-child {
    flex-basis  : 500px;
    margin-left : 15px;
  }

  > span:last-child {
    color: ${({ theme: { textColor } }): string => textColor.darkGray};
  }
`;

const Date = styled.div`
  margin-bottom : 6px;
  font-size     : 16px;
  font-weight   : 500;
  color         : ${({ theme: { textColor } }): string => textColor.black};
`;

const Comment = styled.pre`
  margin-bottom : 10px;
  font-size     : 16px;
  color         : ${({ theme: { textColor } }): string => textColor.gray};
`;

const FileName = styled.a`
  margin-bottom : 6px;
  font-size     : 16px;
  cursor        : pointer;
  color         : ${({ theme: { textColor } }): string => textColor.secondary};
`;

interface IProps {
  comments      : IComment[];
  fetchDocument : (document: IDocument) => Promise<void>;
}

export const CommentsList = ({
  comments,
  fetchDocument,
} : IProps): JSX.Element => (
  <>
    {!!comments.length && comments.map(
      (comment: IComment): JSX.Element => (
        <LineWrapper key={comment.id}>
          <span />
          <span>
            <Date>
              {moment(comment.dateCreated).format('MM/DD/YY [at] h:mm A z')}
              {comment.authorFullName && ` by ${comment.authorFullName}`}
            </Date>

            <Comment>{comment.message}</Comment>

            {comment.document && (
              <FileName
                onClick={(): Promise<void> => fetchDocument(comment?.document ?? {} as IDocument)}
              >
                {comment.document?.fileName}
              </FileName>
            )}
          </span>
        </LineWrapper>
      ),
    )}
  </>
);
